import { Component, Prop, State, h } from '@stencil/core';
import { NavItem } from './nav-item/nav-item';

/**
 * Takes a title text, icon url and url path for each navigation item and correctly displays navigation state based on current url path.
 */
@Component({
  tag: 'side-nav',
  styleUrl: 'side-nav.css',
  shadow: true,
})
export class SideNav {
  /**
   * Represents a navigation item.
   *
   * @typedef {Object} NavItem
   * @property {string} label - The label or title of the navigation item.
   * @property {string} target - The target URL or identifier associated with the navigation item.
   * @property {string} icon - The URL or identifier of the icon associated with the navigation item.
   */
  @Prop() navItems: NavItem[] = [];
  @State() currentPath: string;
  @State() isCollapsed: boolean;

  componentWillLoad() {
    //Path
    this.currentPath = window.location.pathname;

    //Collapsed
    const isCollapsed = localStorage.getItem('side-nav--collapsed');
    this.isCollapsed = isCollapsed ? JSON.parse(isCollapsed) : false;
  }

  private handleCollapse() {
    this.isCollapsed = !this.isCollapsed;

    localStorage.setItem('side-nav--collapsed', JSON.stringify(this.isCollapsed));
  }
  renderNavItem(navItem: NavItem) {
    if (navItem.subItems && navItem.subItems.length > 0) {
      return (
        <nav-item
          label={navItem.label}
          target={navItem.target}
          icon={navItem.icon}
          isActive={this.isActive(navItem)}
          isCollapsed={this.isCollapsed}
          subItems={navItem.subItems}
        ></nav-item>
      );
    } else {
      return (
        <nav-item
          label={navItem.label}
          target={navItem.target}
          icon={navItem.icon}
          isActive={this.isActive(navItem)}
          isCollapsed={this.isCollapsed}
        ></nav-item>
      );
    }
  }

  isActive(navItem: NavItem): boolean {
    if (navItem.target === '/') {
      return this.currentPath === navItem.target;
    }else {
      return this.currentPath.includes(navItem.target);
    }
  }
  render() {
    return (
      <nav>
        {this.navItems?.map(navItem => this.renderNavItem(navItem))}
        <button onClick={this.handleCollapse.bind(this)}>
          {this.isCollapsed ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" color="white" viewBox="0 0 24 24">
              <path fill="currentColor" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" color="white" viewBox="0 0 24 24">
              <path fill="currentColor" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6z" />
            </svg>
          )}
        </button>
      </nav>
    );
  }
}
